<template>
  <div class="menu">
    <ul class="nav">
      <li class="nav__item">
        <router-link class="desc" to="/rules">
          <b>{{ $t("Rules") }}</b>
        </router-link>
      </li>
      <li class="nav__item">
        <button class="desc" @click="$parent.openContactUs()">
          <b>{{ $t("Contact us") }}</b>
        </button>
      </li>
      <li
        :class="['nav__item', { active: $route.name == 'Products' }]"
        v-if="$parent.categories && $parent.categories.length"
      >
        <button
          @click="$emit('chooseCategoty', $parent.categories[0])"
          class="desc"
        >
          <b>{{ $t("Store") }}</b>
        </button>
      </li>
      <li class="nav__item">
        <router-link class="desc" to="/faq">
          <b>{{ $t("FAQ") }}</b>
        </router-link>
      </li>
    </ul>
    <div class="right">
      <router-link
        to="/cart"
        class="cart-icon button icon-button"
        v-if="$parent.isAuth"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_34_1543)">
            <path
              d="M19.7031 7.22904C19.439 6.89772 19.0428 6.70764 18.616 6.70764H14.7643L12.6756 1.9251C12.5461 1.62858 12.2007 1.49307 11.9042 1.62264C11.6076 1.75213 11.4722 2.09756 11.6017 2.39412L13.4855 6.70768H6.51449L8.39828 2.39412C8.52778 2.09756 8.39239 1.75217 8.09582 1.62264C7.7993 1.49307 7.45387 1.6285 7.32438 1.9251L5.23574 6.70768H1.38403C0.957229 6.70768 0.561018 6.89772 0.296917 7.22908C0.0376587 7.5544 -0.0580054 7.9726 0.0344556 8.37658L2.09137 17.361C2.235 17.9883 2.78996 18.4264 3.44094 18.4264H16.5591C17.21 18.4264 17.765 17.9883 17.9086 17.361L19.9655 8.37654C20.058 7.97256 19.9623 7.55436 19.7031 7.22904ZM16.5591 17.2545H3.44094C3.34145 17.2545 3.2543 17.1893 3.23371 17.0994L1.1768 8.11506C1.16067 8.04455 1.18774 7.99151 1.21336 7.95944C1.23711 7.92959 1.2909 7.87955 1.38403 7.87955H4.72399L4.57051 8.231C4.44102 8.52756 4.57641 8.87295 4.87297 9.00248C4.9493 9.03584 5.02883 9.05162 5.10715 9.05162C5.33301 9.05162 5.54824 8.92026 5.64442 8.70006L6.00274 7.87963H13.9973L14.3557 8.70006C14.4518 8.9203 14.6671 9.05162 14.8929 9.05162C14.9712 9.05162 15.0508 9.03584 15.1271 9.00248C15.4237 8.87299 15.5591 8.52756 15.4296 8.231L15.2761 7.87955H18.6161C18.7092 7.87955 18.763 7.92959 18.7867 7.95944C18.8123 7.99154 18.8394 8.04459 18.8233 8.11502L16.7664 17.0994C16.7457 17.1893 16.6586 17.2545 16.5591 17.2545Z"
              fill="white"
            />
            <path
              d="M6.48438 10.4186C6.16078 10.4186 5.89844 10.6809 5.89844 11.0045V15.3014C5.89844 15.625 6.16078 15.8873 6.48438 15.8873C6.80797 15.8873 7.07031 15.625 7.07031 15.3014V11.0045C7.07031 10.6809 6.80801 10.4186 6.48438 10.4186Z"
              fill="white"
            />
            <path
              d="M10 10.4186C9.67641 10.4186 9.41406 10.6809 9.41406 11.0045V15.3014C9.41406 15.625 9.67641 15.8873 10 15.8873C10.3236 15.8873 10.5859 15.625 10.5859 15.3014V11.0045C10.5859 10.6809 10.3236 10.4186 10 10.4186Z"
              fill="white"
            />
            <path
              d="M13.5156 10.4186C13.192 10.4186 12.9297 10.6809 12.9297 11.0045V15.3014C12.9297 15.625 13.192 15.8873 13.5156 15.8873C13.8392 15.8873 14.1016 15.625 14.1016 15.3014V11.0045C14.1015 10.6809 13.8392 10.4186 13.5156 10.4186Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_34_1543">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div v-if="$parent.cartContents.length" class="indicator">
          {{ $parent.cartContents.length }}
        </div>
      </router-link>
      <router-link
        to="/profile"
        class="button profile-icon icon-button"
        v-if="$parent.isAuth"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.85724 9.63408C11.1808 9.63408 12.3267 9.15938 13.2633 8.22279C14.1996 7.28636 14.6744 6.14058 14.6744 4.81689C14.6744 3.49365 14.1997 2.34771 13.2632 1.41098C12.3266 0.4747 11.1806 0 9.85724 0C8.53354 0 7.38776 0.4747 6.45132 1.41113C5.51489 2.34756 5.04004 3.49349 5.04004 4.81689C5.04004 6.14058 5.51489 7.28652 6.45132 8.22295C7.38806 9.15922 8.534 9.63408 9.85724 9.63408ZM7.28018 2.23983C7.99872 1.5213 8.84161 1.17203 9.85724 1.17203C10.8727 1.17203 11.7158 1.5213 12.4344 2.23983C13.153 2.95852 13.5024 3.80157 13.5024 4.81689C13.5024 5.83251 13.153 6.6754 12.4344 7.39409C11.7158 8.11278 10.8727 8.46205 9.85724 8.46205C8.84192 8.46205 7.99902 8.11263 7.28018 7.39409C6.56149 6.67555 6.21207 5.83251 6.21207 4.81689C6.21207 3.80157 6.56149 2.95852 7.28018 2.23983Z"
            fill="white"
          />
          <path
            d="M18.2863 15.379C18.2593 14.9893 18.2047 14.5642 18.1242 14.1153C18.0431 13.663 17.9385 13.2354 17.8134 12.8447C17.684 12.4408 17.5084 12.0659 17.2919 11.7277C17.0707 11.3859 16.7914 11.0911 16.4585 10.8473C16.1529 10.6277 15.7799 10.4349 15.3497 10.2673C14.9153 10.095 14.4487 9.98582 13.9503 9.93861C13.4055 9.88401 12.9124 9.8623 12.4721 9.8623H7.24318C6.81903 9.8623 6.33313 9.88401 5.79154 9.93861C5.29285 9.98582 4.82633 10.095 4.39189 10.2673C3.96088 10.4349 3.58596 10.6277 3.26618 10.8473C2.93548 11.0921 2.65454 11.386 2.43002 11.7277C2.21315 12.0661 2.03905 12.4408 1.90876 12.8447C1.78373 13.2354 1.67926 13.663 1.59898 14.1153C1.51843 14.5642 1.46356 14.9893 1.43652 15.379C1.39907 16.0307 1.38042 16.5237 1.38042 16.858C1.38042 17.2228 1.39907 17.6379 1.43652 18.1021C1.48347 18.7467 1.66697 19.1638 1.98598 19.3533C2.31392 19.5486 2.76969 19.6453 3.34915 19.6453H16.6503C17.2298 19.6453 17.6857 19.5486 18.0136 19.3533C18.326 19.1723 18.5098 18.7615 18.5644 18.1159C18.5957 17.7502 18.6118 17.3795 18.6118 17.0038C18.6118 16.6686 18.5973 16.2051 18.5682 15.6136L18.2863 15.379ZM4.4461 14.9268C4.5034 14.572 4.58591 14.2157 4.69297 13.8577C4.81596 13.4301 4.96181 13.015 5.13062 12.6125C5.30099 12.2096 5.49304 11.8293 5.70788 11.4716C5.94438 11.0691 6.21192 10.7197 6.51057 10.423C6.83427 10.1159 7.20006 9.86109 7.60806 9.65872C7.96915 9.4814 8.37636 9.36439 8.82975 9.30768C9.28332 9.25097 9.79999 9.22262 10.3796 9.22262H12.9484C13.2874 9.22262 13.6962 9.2369 14.1758 9.26544C14.6396 9.29316 15.0582 9.33539 15.4318 9.3921C15.8804 9.46346 16.2647 9.57223 16.5847 9.71839C16.9489 9.8914 17.2537 10.1088 17.4992 10.3705C17.7193 10.5955 17.8854 10.8635 17.9975 11.1745C18.1061 11.488 18.1696 11.8288 18.188 12.1968C18.188 12.1968 18.188 12.2149 18.188 12.2151C18.1923 12.6186 18.1777 13.0331 18.144 13.4594C18.1106 13.899 18.0521 14.3223 17.9686 14.7295C17.8883 15.0909 17.7723 15.449 17.6204 15.8037L17.4556 16.1972H5.54523L4.4461 14.9268Z"
            fill="white"
          />
        </svg>
      </router-link>
      <div class="link-container" v-else>
        <button class="button" @click="$parent.openSignIn()">
          {{ $t("Log In") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: [],
  data: function () {
    return {};
  },
  methods: {},
};
</script>
